import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Discussion, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  postComment(request: Boundaries["postComment"]["request"]): void;
}

function usePostComment(discussion: Identifiable<Discussion>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isPostCommentRequestPending(discussion),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isPostCommentRequestSuccess(discussion),
    ),
    isRequestFailure: useSelector(() =>
      selector.isPostCommentRequestFailure(discussion),
    ),
    postComment: core.postComment,
  };
}

export { usePostComment };
